<template>
    <div class="public_container payment_confirmation_wrap" v-loading="formLoading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <ul class="list_content" v-if="source_type == 'order' && confirmType === 'confirm'">
                <li>
                    <p>
                        关联订单：<span class="link-label">{{ receivableDetails.basic_info.order_no }}</span>
                    </p>
                    <div class="mobile_detail_head_user_wrap">
                        客户联系人：
                        <!-- <div
                            class="mobile_detail_head_user"
                            v-if="receivableDetails.basic_info && receivableDetails.basic_info.contact_id"
                            @click="handleClickUserInfo({ id: receivableDetails.basic_info.contact_id })"
                        >
                            <img
                                :src="
                                    receivableDetails.basic_info.contact_avatar
                                        ? receivableDetails.basic_info.contact_avatar
                                        : defaultImg
                                "
                                alt=""
                            />
                            <span class="ellipsis">{{ receivableDetails.basic_info.contact_name }}</span>
                        </div> -->
                        <span>{{
                            receivableDetails.basic_info.customer_contact_info &&
                            receivableDetails.basic_info.customer_contact_info.name
                        }}</span>
                    </div>
                    <p>订单总金额：{{ receivableDetails.basic_info.order_amount }}</p>
                    <div class="mobile_detail_head_user_wrap">
                        销售：
                        <div
                            class="mobile_detail_head_user"
                            v-if="receivableDetails.basic_info && receivableDetails.basic_info.salesperson_info"
                            @click="handleClickUserInfo(receivableDetails.basic_info.salesperson_info)"
                        >
                            <img
                                :src="
                                    receivableDetails.basic_info.salesperson_info &&
                                    receivableDetails.basic_info.salesperson_info.avatar
                                        ? receivableDetails.basic_info.salesperson_info.avatar
                                        : defaultImg
                                "
                                alt=""
                            />
                            <span class="ellipsis">{{
                                receivableDetails.basic_info.salesperson_info &&
                                receivableDetails.basic_info.salesperson_info.name
                            }}</span>
                        </div>
                    </div>
                    <p>回款公司：{{ receivableDetails.basic_info.payment_company_name }}</p>
                    <p>回款日期：{{ receivableDetails.basic_info.payment_date }}</p>
                    <p>回款方式：{{ receivableDetails.basic_info.payment_method_name }}</p>
                    <p>本次回款金额：{{ receivableDetails.basic_info.payment_amount }}</p>
                    <p>备注：<br />{{ receivableDetails.basic_info.remark }}</p>
                    <div>
                        附件：<br />
                        <ul
                            class="voucher_list"
                            v-if="
                                receivableDetails.basic_info.attachments &&
                                receivableDetails.basic_info.attachments.length
                            "
                        >
                            <li
                                :key="index"
                                class="voucher_item"
                                v-for="(item, index) in receivableDetails.basic_info.attachments"
                                @click="handleClickPreviewImg(index, receivableDetails.basic_info.attachments)"
                            >
                                <van-image :src="item" alt=""> </van-image>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
            <van-form
                label-width="9.5em"
                input-align="right"
                scroll-to-error
                :show-error-message="false"
                ref="paymentConfirmationForm"
                class="custom_mobile_form"
            >
                <template v-if="confirmType === 'confirm'">
                    <van-field
                        v-model="receivableDetails.receivable_info.receivable_amount"
                        name="receivable_amount"
                        label="应收款金额"
                        placeholder="自动带出"
                        readonly
                    >
                    </van-field>
                    <van-field
                        required
                        v-model="paymentInfoForm.payment_method_text"
                        name="payment_method_text"
                        label="收款方式"
                        placeholder="请选择"
                        readonly
                        is-link
                        @click="handleClickSelectPayType('-1')"
                        :rules="[{ required: true, message: '请选择' }]"
                    >
                    </van-field>
                    <van-field
                        required
                        v-model="paymentInfoForm.confirm_time"
                        name="confirm_time"
                        label="回款日期"
                        placeholder="请选择"
                        readonly
                        is-link
                        @click="handleClickSelectPayTime('-1')"
                        :rules="[{ required: true, message: '请选择' }]"
                    >
                    </van-field>
                    <van-field
                        v-model="paymentInfoForm.remark"
                        name="remark"
                        label="备注"
                        placeholder="请输入"
                        rows="4"
                        maxlength="200"
                        autosize
                        type="textarea"
                        input-align="left"
                        class="vertical_input_wrap"
                    >
                    </van-field>
                    <van-field name="voucher" label="收款凭证" class="vertical_input_wrap">
                        <template #input>
                            <div class="upload_input_wrap">
                                <ul class="voucher_list">
                                    <li
                                        :key="index"
                                        class="voucher_item"
                                        v-for="(item, index) in paymentInfoForm.voucher"
                                    >
                                        <van-image :src="item" alt=""> </van-image>
                                        <i
                                            @click="paymentInfoForm.voucher.splice(index, 1)"
                                            class="iconfont icon-guanbi_dise"
                                        ></i>
                                    </li>
                                    <li @click="handleClickUploadFile(paymentInfoForm)" class="upload_img_wrap">
                                        <i class="el-icon-plus"></i>
                                    </li>
                                </ul>
                                <p class="hint">请上传银行交易凭证截图（建议大小不超过5M，支持png、jpg等格式）</p>
                            </div>
                        </template>
                    </van-field>
                </template>
                <template v-else>
                    <van-field
                        v-model="paymentInfoForm.receivable_amount_total"
                        name="receivable_amount_total"
                        label="应收款总金额"
                        placeholder="自动带出"
                        readonly
                    >
                    </van-field>
                    <ul>
                        <li class="payable_list_item" v-for="(row, rowIndex) in paymentInfoForm.paymentBatchInfo">
                            <div class="payable_list_item_top">
                                <template v-if="source_type == 'order'">
                                    <div class="mobile_detail_head_user">
                                        <img
                                            :src="
                                                row.basic_info.salesperson_info.avatar
                                                    ? row.basic_info.salesperson_info.avatar
                                                    : defaultImg
                                            "
                                            alt=""
                                        />
                                        <span class="ellipsis">{{ row.basic_info.salesperson_info.name }}</span>
                                    </div>
                                    <span>订单编号：</span>
                                    <span class="link-label">{{ row.basic_info && row.basic_info.order_no }}</span>
                                    <i
                                        class="iconfont icon-shanchu1 payable_list_item_delete"
                                        @click="handleClickBatchDelete(rowIndex)"
                                    ></i>
                                </template>
                                <template v-else-if="source_type == 'purchase_refund'">
                                    <div class="mobile_detail_head_user">
                                        <img
                                            :src="
                                                row.basic_info.uid_info && row.basic_info.uid_info.avatar
                                                    ? row.basic_info.uid_info.avatar
                                                    : defaultImg
                                            "
                                            alt=""
                                        />
                                        <span class="ellipsis">{{
                                            row.basic_info.uid_info && row.basic_info.uid_info.name
                                        }}</span>
                                    </div>
                                    <span>应收编号：</span><span class="link-label">{{ row.receivable_no }}</span>
                                </template>
                            </div>
                            <div class="payable_list_item_content">
                                <template v-if="source_type == 'order'">
                                    <p>
                                        回款编号：<span class="link-label">{{ row.receivable_no }}</span>
                                    </p>
                                    <p>
                                        客户公司：<span class="link-label">{{
                                            row.basic_info &&
                                            row.basic_info.customer_info &&
                                            row.basic_info.customer_info.name
                                        }}</span>
                                    </p>
                                    <p>回款公司：{{ row.basic_info && row.basic_info.payment_company_name }}</p>
                                    <div class="payable_list_item_amount">
                                        <div>
                                            <div class="payable_list_item_amount_percent percent_bg1">
                                                应收总金额：¥{{ row.receivable_info.receivable_amount }}
                                            </div>
                                        </div>
                                        <div>
                                            <div class="payable_list_item_amount_percent percent_bg2">
                                                已收总金额：¥{{ row.receivable_info.confirmed_amount }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="source_type == 'purchase_refund'">
                                    <p>
                                        采购编号：<span
                                            class="link-label"
                                            @click="handleClickRelateId(row.basic_info && row.basic_info.purchase_id)"
                                            >{{ row.basic_info && row.basic_info.purchase_refund_no }}</span
                                        >
                                    </p>
                                    <p>
                                        审批编号：<span class="link-label">{{
                                            row.basic_info && row.basic_info.approval_id
                                        }}</span>
                                    </p>
                                    <p>供应商名称：{{ row.basic_info && row.basic_info.supplier_name }}</p>
                                    <div class="payable_list_item_amount">
                                        <div>
                                            <div class="payable_list_item_amount_percent percent_bg1">
                                                应收款金额：¥{{ row.receivable_info.receivable_amount }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <p class="custom_cell_bottom_line">
                                    <van-field
                                        required
                                        v-model="row.payment_method_text"
                                        name="payment_method_text"
                                        label="收款方式"
                                        placeholder="请选择"
                                        readonly
                                        is-link
                                        @click="handleClickSelectPayType(rowIndex)"
                                        :rules="[{ required: true, message: '请选择' }]"
                                    >
                                    </van-field>
                                </p>
                                <p class="custom_cell_bottom_line">
                                    <van-field
                                        required
                                        v-model="row.confirm_time"
                                        name="confirm_time"
                                        label="回款日期"
                                        placeholder="请选择"
                                        readonly
                                        is-link
                                        @click="handleClickSelectPayTime(rowIndex)"
                                        :rules="[{ required: true, message: '请选择' }]"
                                    >
                                    </van-field>
                                </p>
                                <p class="custom_cell_bottom_line">
                                    <van-field
                                        v-model="row.remark"
                                        name="remark"
                                        label="备注"
                                        placeholder="请输入"
                                        rows="4"
                                        maxlength="200"
                                        autosize
                                        type="textarea"
                                        input-align="left"
                                        class="vertical_input_wrap"
                                    >
                                    </van-field>
                                </p>
                                <div>
                                    <van-field name="voucher" label="收款凭证" class="vertical_input_wrap">
                                        <template #input>
                                            <div class="upload_input_wrap">
                                                <ul class="voucher_list">
                                                    <li
                                                        :key="index"
                                                        class="voucher_item"
                                                        v-for="(item, index) in row.voucher"
                                                    >
                                                        <van-image :src="item" alt=""> </van-image>
                                                        <i
                                                            @click="row.voucher.splice(index, 1)"
                                                            class="iconfont icon-guanbi_dise"
                                                        ></i>
                                                    </li>
                                                    <li @click="handleClickUploadFile(row)" class="upload_img_wrap">
                                                        <i class="el-icon-plus"></i>
                                                    </li>
                                                </ul>
                                                <p class="hint">
                                                    请上传银行交易凭证截图（建议大小不超过5M，支持png、jpg等格式）
                                                </p>
                                            </div>
                                        </template>
                                    </van-field>
                                </div>
                            </div>
                        </li>
                    </ul>
                </template>
            </van-form>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>

        <!-- 选择支付方式 -->
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            v-if="payTypeRadioPicker"
            :show="payTypeRadioPicker"
        >
            <div class="custome_radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        v-for="item in payTypeList"
                        class="radio_option_item"
                        @click="handleClickPayTypeOption(item)"
                        v-text="item.name"
                    ></li>
                </ul>
                <div class="cancel_btn" @click="payTypeRadioPicker = false">取消</div>
            </div>
        </van-overlay>
        <!-- 选择时间 -->
        <van-popup
            :style="{ height: '352px' }"
            round
            position="bottom"
            v-if="showDatePopupShow"
            v-model="showDatePopupShow"
        >
            <van-datetime-picker
                v-model="currentTime"
                type="datetime"
                title="选择时间"
                @cancel="showDatePopupShow = false"
                @confirm="handleDateCalenderConfirm"
                :min-date="dateCalendarMin"
                :max-date="dateCalendarMax"
            />
        </van-popup>
        <userDetailDialog
            v-if="userDetailPopupShow"
            :userDetailPopupShow.sync="userDetailPopupShow"
            :userId="userDetailId"
        />
    </div>
</template>
<script>
import { ReceivableBatchConfirm, ReceivableDetail, ReceivableDetailBatch } from "@/api";
import { ImagePreview } from "vant";
import { uploadImg } from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
export default {
    name: "PaymentConfirmation",
    components: { ReturnNavBar, userDetailDialog },
    data() {
        return {
            formLoading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            receivable_no: "", // 应收编号
            confirmType: "", // confirm: 单个确认, batchConfirm: 批量确认
            source_type: "",
            receivableDetails: {
                source_type: "",
                basic_info: {}, // 订单信息
                receivable_info: {}, // 财务信息
                other_info: {}, // 驳回信息
                other_info: {}, // 作废信息
            },
            paymentInfoForm: {
                payment_method: "",
                confirm_time: "",
                remark: "",
                voucher: [],
                paylog_bill: [],
                pay_amount: "",

                receivable_amount_total: "", // 批量确认应收款总金额
                paymentBatchInfo: [],
            },
            payTypeRadioPicker: false,
            payTypeList: [
                { name: "电汇", value: 1 },
                { name: "微信", value: 2 },
                { name: "支付宝", value: 3 },
                { name: "现金", value: 4 },
                { name: "银行承兑", value: 5 },
                { name: "商业承兑", value: 6 },
                { name: "支票", value: 7 },
            ],
            showDatePopupShow: false,
            currentTime: "",
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            btnDisabled: false,
            // 人员详细信息
            userDetailPopupShow: false,
            userDetailId: "",
            // 当前批量操作的数据
            batchOperateIndex: "", // -1：单个操作，有值：批量操作
        };
    },
    created() {
        if (this.$route.query) {
            this.receivable_no = this.$route.query.receivable_no;
            this.confirmType = this.$route.query.confirmType;
            this.source_type = this.$route.query.source_type;
            if (this.confirmType === "confirm") {
                // 单个确认
                this.getReceivableDetail();
            } else {
                // 批量确认
                this.getReceivableDetailBatch();
            }
        }
    },
    methods: {
        // 应收详情-单个
        getReceivableDetail() {
            ReceivableDetail({ receivable_no: this.receivable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.receivableDetails = data;
                    this.paymentInfoForm.confirm_time =
                        this.receivableDetails.basic_info && this.receivableDetails.basic_info.payment_date
                            ? this.formatDate(this.receivableDetails.basic_info.payment_date, "datetime")
                            : "";
                }
            });
        },
        // 应收详情-批量
        getReceivableDetailBatch() {
            ReceivableDetailBatch({ receivable_nos: this.receivable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    this.paymentInfoForm.paymentBatchInfo = data;
                    this.paymentInfoForm.receivable_amount_total = this.paymentInfoForm.paymentBatchInfo.reduce(
                        (total, item) => total + Number(item.receivable_info.receivable_amount),
                        0
                    );
                }
            });
        },
        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        // 图片预览
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        // 批量删除
        handleClickBatchDelete(index) {
            this.paymentInfoForm.paymentBatchInfo.splice(index, 1);
        },
        // 选择收款方式
        handleClickSelectPayType(index) {
            this.batchOperateIndex = index;
            this.payTypeRadioPicker = true;
        },
        // 收款方式选择确认
        handleClickPayTypeOption(item) {
            if (this.batchOperateIndex != "-1") {
                // 批量操作选择的
                this.$set(this.paymentInfoForm.paymentBatchInfo[this.batchOperateIndex], "payment_method", item.value);
                this.$set(
                    this.paymentInfoForm.paymentBatchInfo[this.batchOperateIndex],
                    "payment_method_text",
                    item.name
                );
            } else {
                // 单个确认操作选择的
                this.paymentInfoForm.payment_method = item.value;
                this.paymentInfoForm.payment_method_text = item.name;
            }
            this.payTypeRadioPicker = false;
        },
        // 选择时间
        handleClickSelectPayTime(index) {
            this.batchOperateIndex = index;
            this.showDatePopupShow = true;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.showDatePopupShow = false;
            if (this.batchOperateIndex != "-1") {
                // 批量操作选择的
                this.$set(
                    this.paymentInfoForm.paymentBatchInfo[this.batchOperateIndex],
                    "confirm_time",
                    this.formatDate(date, "datetime")
                );
            } else {
                // 单个确认操作选择的
                this.paymentInfoForm.confirm_time = this.formatDate(date, "datetime");
            }
        },
        formatDate(dateString, date_type) {
            // 创建日期对象
            const dateObj = new Date(dateString);
            // 获取年、月、日
            const year = dateObj.getFullYear();
            const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
            const day = ("0" + dateObj.getDate()).slice(-2);
            const hours = ("0" + dateObj.getHours()).slice(-2);
            const minutes = ("0" + dateObj.getMinutes()).slice(-2);
            const seconds = ("0" + dateObj.getSeconds()).slice(-2);
            let formattedDateTime = "";
            if (date_type === "date") {
                formattedDateTime = year + "-" + month + "-" + day;
            } else if (date_type === "year-month") {
                formattedDateTime = year + "-" + month;
            } else if (date_type === "datetime") {
                formattedDateTime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            }
            return formattedDateTime;
        },
        // 上传图片
        handleClickUploadFile(formData) {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024)) return that.$toast("图片大小不允许超过5m");
                if (formData.voucher.length + files.length > 5) return that.$toast("最多只能上传5张");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            formData.voucher.push(res.file_path);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        handleClickConfirm() {
            this.$refs.paymentConfirmationForm.validate().then(() => {
                console.log(this.paymentInfoForm.paymentBatchInfo);
                let receivables = [];
                if (this.confirmType === "confirm") {
                    // 单个确认
                    receivables.push({
                        receivable_no: this.receivable_no,
                        payment_method: this.paymentInfoForm.payment_method,
                        confirm_time: this.paymentInfoForm.confirm_time,
                        remark: this.paymentInfoForm.remark,
                        voucher: this.paymentInfoForm.voucher,
                    });
                } else {
                    // 批量确认
                    receivables = this.paymentInfoForm.paymentBatchInfo.map((item) => ({
                        receivable_no: item.receivable_no,
                        payment_method: item.payment_method,
                        confirm_time: item.confirm_time,
                        remark: item.remark,
                        voucher: item.voucher,
                    }));
                }
                if (!receivables.length) return this.$toast("至少保留一条应收单");
                this.btnDisabled = true;
                this.formLoading = true;
                ReceivableBatchConfirm({ receivables: receivables })
                    .then((res) => {
                        if (res.code === 200) {
                            this.btnDisabled = false;
                            this.formLoading = false;
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.go(-1);
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                            this.formLoading = false;
                            this.$toast(res.message);
                        }
                    })
                    .catch((res) => {
                        this.$toast(res.message);
                        this.btnDisabled = false;
                        this.formLoading = false;
                    });
            });
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.$router.push({
                name: "purchase_detail",
                query: {
                    purchase_id: purchaseId,
                },
            });
        },
        //查看订单详情
        handleClickOrderDetail() {
            this.$router.push({
                name: "OrderDetail",
                // params: {
                //     isPush: true,
                // },
                query: {
                    order_id: this.receivableDetails.basic_info.order_no,
                    name: this.receivableDetails.basic_info.order_no,
                    query_type: "order_no",
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.payment_confirmation_wrap {
    .mobile_container {
        background-color: #ffffff;

        .payable_list_item {
            width: 100%;
            padding: 10px 16px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 10px;

            .payable_list_item_top {
                padding-bottom: 8px;
                display: flex;
                align-items: center;
                position: relative;

                .mobile_head_user {
                    font-size: 0;
                    display: flex;
                    align-items: center;
                    background: #edf0f4;
                    border-radius: 22px;
                    margin-right: 8px;

                    img {
                        width: 22px;
                        min-width: 22px;
                        height: 22px;
                        border-radius: 50%;
                    }

                    span {
                        flex: 1;
                        font-size: 14px;
                        color: rgb(51, 51, 51);
                        font-weight: bold;
                        display: inline-block;
                        padding: 0 8px;
                        box-sizing: border-box;
                        max-width: 78px;
                    }
                }

                & > span {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                }

                .link-label {
                    color: rgba(41, 144, 255, 1);
                }

                .payable_list_item_delete {
                    position: absolute;
                    right: 0;
                }
            }

            .payable_list_item_content {
                p {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(102, 102, 102, 1);
                    & + p {
                        margin-top: 8px;
                    }

                    .link-label {
                        color: rgba(41, 144, 255, 1);
                    }
                }

                .payable_list_item_amount {
                    width: 100%;
                    padding: 4px;
                    border-radius: 4px;
                    background: #ffffff;
                    border: 2px solid rgba(237, 240, 244, 1);
                    margin-top: 8px;
                    & > div {
                        height: 24px;
                        display: flex;
                        justify-content: space-between;
                        gap: 4px;
                    }
                    & > div + div {
                        margin-top: 4px;
                    }
                    .payable_list_item_amount_percent {
                        width: 100%;
                        height: 24px;
                        padding: 0 8px;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(102, 102, 102, 1);
                        border-radius: 4px;
                        box-sizing: border-box;
                    }
                    .percent_bg1 {
                        background-color: rgba(41, 144, 255, 0.16);
                    }
                    .percent_bg2 {
                        background-color: rgba(41, 144, 255, 0.08);
                        padding-right: 0;
                    }
                    .percent_bg3 {
                        background-color: rgba(0, 0, 0, 0.04);
                        color: rgba(51, 51, 51, 1);
                        font-weight: 700;
                        text-align: right;
                        padding-left: 0;
                    }
                }
            }

            .van-cell {
                position: relative;
                padding: 10px 0 10px 7px;
                font-size: 14px;
                line-height: 22px;

                &::before {
                    left: 0;
                }
            }
            .custom_cell_bottom_line {
                position: relative;
                &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    box-sizing: border-box;
                    pointer-events: none;
                    right: -16px;
                    bottom: 0;
                    left: -16px;
                    border-bottom: 1px solid #ebedf0;
                    -webkit-transform: scaleY(0.5);
                    transform: scaleY(0.5);
                }
            }
        }
    }
    .add_footer_wrap {
        padding: 5px 16px;
        // background-color: rgba(247, 248, 250, 1);
        background-color: #ffffff;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
.list_content {
    padding: 10px 16px;
    li {
        border-radius: 6px;
        background: rgba(249, 249, 249, 1);
        padding: 8px 10px 2px;
        margin-bottom: 8px;
        & > p,
        & > div {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            margin-bottom: 8px;
        }
    }
    .form_module_content {
        padding: 0;
    }
}
.voucher_list {
    margin-top: 4px;
    display: flex;
    gap: 8px;

    .voucher_item {
        width: 48px;
        height: 48px;
        border: 1px dashed #d9d9d9;
        cursor: pointer;
        position: relative;
        text-align: center;
        line-height: 48px;
        border-radius: 4px;

        .van-image {
            max-width: 100%;
            max-height: 100%;
        }

        img {
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
        }
    }
}
</style>
